import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { Request } from '../../../../../models/Request';
import * as requestsActions from '../actions';
import { IRequestsState } from '../states';

export const adapter: EntityAdapter<Request> = createEntityAdapter<Request>();

const requestsInitialStates: IRequestsState = adapter.getInitialState({
	loading: false,
	loaded: false,
});

const reducer = createReducer(
	requestsInitialStates,
	on(requestsActions.getRequests, (state) => ({ ...state, loading: true, loaded: false })),
	on(requestsActions.getRequestsSuccess, (state, { requests }) => {
		return adapter.setAll(requests, { ...state, loading: false, loaded: true });
	})
);

export function requestsReducer(state: any | undefined, action: Action) {
	return reducer(state, action);
}
